import React from 'react'
import BenefitSection from './BenefitSection'
import ServiceCard from './ServiceCard'
import ScheduleDialog from './ScheduleDialog'
import FeedbackDialog from './FeedbackDialog'
import { useBenefits } from '../BenefitsProvider'
import { useTranslation } from '../../../hooks/useTranslation'
import CoachServicesPage from './CoachServicesPage'
import SelectTabNav from './SelectTabNav'
import { SERVICE_REQUEST_ICONS } from '../ServiceRequestIcons'

const SelectCoachServicesPage = () => {
  const { current_user, coach } = useBenefits()
  const { t } = useTranslation()

  const { isLiaison, liaison_image_url } = coach

  const white = 'text-white hover:!underline hover:!text-white'

  const services = {
    intro_call: {
      requestType: 'ServiceRequest::OrientationCall',
      title: t('service_card.coach_introduction.title'),
      description: t('service_card.coach_introduction.description'),
      buttonText: t('service_card.coach_introduction.button_text'),
      iconType: SERVICE_REQUEST_ICONS['ServiceRequest::OrientationCall'],
      classes: 'bg-intoo-select',
      linkColor: white,
      photoUrl: isLiaison
        ? liaison_image_url
        : coach.transparent_photo || coach.photo,
      liaison: isLiaison,
      fullWidth: true,
      coachCard: true,
    },
    early: [
      {
        requestType: 'ServiceRequest::ResumeReview',
        title: t('service_card.resume_development.title'),
        description: t('service_card.resume_development.description'),
        buttonText: t('service_card.resume_development.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::ResumeReview'],
        classes: 'bg-intoo-blue-medium',
        linkColor: white,
      },
      {
        requestType: 'ServiceRequest::JobSearchStrategy',
        title: t('service_card.job_search_strategy.title'),
        description: t('service_card.job_search_strategy.description'),
        buttonText: t('service_card.job_search_strategy.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::JobSearchStrategy'],
        classes: 'bg-intoo-blue-medium',
        linkColor: white,
      },
      {
        requestType: 'ServiceRequest::StrengthsAssessment',
        title: t('service_card.strengths_ssessment.title'),
        description: t('service_card.strengths_ssessment.description'),
        buttonText: t('service_card.strengths_ssessment.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::StrengthsAssessment'],
        classes: 'bg-intoo-blue-light',
      },
      {
        requestType: 'ServiceRequest::CoverLetterReview',
        title: t('service_card.cover_letter_review.title'),
        description: t('service_card.cover_letter_review.description'),
        buttonText: t('service_card.cover_letter_review.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::CoverLetterReview'],
        classes: 'bg-intoo-blue-light',
      },
      {
        requestType: 'ServiceRequest::CareerPivotPlanning',
        title: t('service_card.career_pivot_planning.title'),
        description: t('service_card.career_pivot_planning.description'),
        buttonText: t('service_card.career_pivot_planning.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::CareerPivotPlanning'],
        classes: 'bg-intoo-blue-bright',
        fullWidth: true,
        linkColor: white,
      },
      {
        requestType: 'ServiceRequest::LinkedInReview',
        title: t('service_card.linkedin_optimization.title'),
        description: t('service_card.linkedin_optimization.description'),
        buttonText: t('service_card.linkedin_optimization.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::LinkedInReview'],
        classes: 'bg-intoo-blue-bright',
        linkColor: white,
        fullWidth: true,
      },
    ],
    midway: [
      {
        requestType: 'ServiceRequest::ExecutiveBio',
        title: t('service_card.executive_bio.title'),
        description: t('service_card.executive_bio.description'),
        buttonText: t('service_card.executive_bio.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::ExecutiveBio'],
        classes: 'bg-intoo-blue-light',
      },
      {
        requestType: 'ServiceRequest::NetworkingStrategy',
        title: t('service_card.networking_strategy.title'),
        description: t('service_card.networking_strategy.description'),
        buttonText: t('service_card.networking_strategy.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::NetworkingStrategy'],
        classes: 'bg-intoo-blue-medium',
        linkColor: white,
      },
      {
        requestType: 'ServiceRequest::RecruiterTargeting',
        title: t('service_card.recruiter_targeting.title'),
        description: t('service_card.recruiter_targeting.description'),
        buttonText: t('service_card.recruiter_targeting.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::RecruiterTargeting'],
        classes: 'bg-intoo-blue-light',
      },
      {
        requestType: 'ServiceRequest::BoardSearch',
        title: t('service_card.board_search.title'),
        description: t('service_card.board_search.description'),
        buttonText: t('service_card.board_search.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::BoardSearch'],
        classes: 'bg-intoo-blue-light',
      },
      {
        requestType: 'ServiceRequest::TargetCompanyResearch',
        title: t('service_card.targeted_research.title'),
        description: t('service_card.targeted_research.description'),
        buttonText: t('service_card.targeted_research.button_text_select'),
        iconType:
          SERVICE_REQUEST_ICONS['ServiceRequest::TargetCompanyResearch'],
        classes: 'bg-intoo-blue-bright',
        linkColor: white,
        fullWidth: true,
      },
      {
        requestType: 'ServiceRequest::InterviewPrep',
        title: t('service_card.interview_prep.title'),
        description: t('service_card.interview_prep.description'),
        buttonText: t('service_card.interview_prep.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::InterviewPrep'],
        classes: 'bg-intoo-blue-medium',
        linkColor: white,
      },
      {
        requestType: 'ServiceRequest::MockInterview',
        title: t('service_card.mock_interview.title'),
        description: t('service_card.mock_interview.description'),
        buttonText: t('service_card.mock_interview.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::MockInterview'],
        classes: 'bg-intoo-blue-medium',
        linkColor: white,
      },
    ],
    closing: [
      {
        requestType: 'ServiceRequest::NegotiationStrategy',
        title: t('service_card.negotiation_strategy.title'),
        description: t('service_card.negotiation_strategy.description'),
        buttonText: t('service_card.negotiation_strategy.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::NegotiationStrategy'],
        classes: 'bg-intoo-blue-medium',
        linkColor: white,
      },
      {
        requestType: 'ServiceRequest::OnboardingSupport',
        title: t('service_card.onboarding_support.title_select'),
        description: t('service_card.onboarding_support.description'),
        buttonText: t('service_card.onboarding_support.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::OnboardingSupport'],
        classes: 'bg-intoo-blue-light',
      },
      {
        requestType: 'ServiceRequest::JobSearchBurnout',
        title: t('service_card.job_search_burnout.title'),
        description: t('service_card.job_search_burnout.description'),
        buttonText: t('service_card.job_search_burnout.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::JobSearchBurnout'],
        classes: 'bg-intoo-blue-bright',
        linkColor: white,
        fullWidth: true,
      },
      {
        requestType: 'ServiceRequest::RetirementSupport',
        title: t('service_card.retirement_support.title'),
        description: t('service_card.retirement_support.description'),
        buttonText: t('service_card.retirement_support.button_text'),
        iconType: SERVICE_REQUEST_ICONS['ServiceRequest::RetirementSupport'],
        classes: 'bg-intoo-blue-light',
        fullWidth: true,
      },
    ],
  }

  const allServices = [
    services.intro_call,
    ...services.early,
    ...services.midway,
    ...services.closing,
  ]

  return (
    <CoachServicesPage>
      <BenefitSection className="md:mb-4">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <ServiceCard {...services.intro_call} />
        </div>
      </BenefitSection>
      <SelectTabNav services={services}>
        <ScheduleDialog
          current_user={current_user}
          coach={coach}
          services={allServices}
        />
        <FeedbackDialog />
      </SelectTabNav>
    </CoachServicesPage>
  )
}
export default SelectCoachServicesPage
